<template>
  <div class="overflow-scroll">
    <expand-new-login-anomaly-details
      v-if="details && isNewLoginType"
      :details="details"
    ></expand-new-login-anomaly-details>
    <expand-excess-login-anomaly-details
      v-else-if="details && isExcessProcessType"
      :details="details"
    ></expand-excess-login-anomaly-details>
  </div>
</template>

<script>
import ExpandNewLoginAnomalyDetails from '@/components/expand/ExpandNewLoginAnomalyDetails.vue'
import ExpandExcessLoginAnomalyDetails from '@/components/expand/ExpandExcessLoginAnomalyDetails.vue'

export default {
  name: 'ExpandLoginAnomalyDetails',
  props: {
    details: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  methods: {},
  created () {
    if (this.details.anomalyMetadata.drillDownResult.drillDownTemplate) {
      this.detectionType = this.details.anomalyMetadata.drillDownResult.drillDownTemplate
    }
  },
  computed: {
    isNewLoginType () {
      return this.details.anomalyMetadata.drillDownResult.drillDownTemplate === 'NEW_LOGIN'
    },
    isExcessProcessType () {
      return this.details.anomalyMetadata.drillDownResult.drillDownTemplate === 'EXCESS_LOGIN'
    }
  },
  components: {
    ExpandNewLoginAnomalyDetails,
    ExpandExcessLoginAnomalyDetails
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.material-icons {
  font-size: 1.3em;
  line-height: 36px;
  vertical-align: middle;
  color: var(--gray-500);
  background: transparent;
}

.el-divider--vertical {
  margin: 0px;
}

>>> .el-button {
  background-color: var(--aluminum-800);
  color: white;
}

.footer-buttons {
  &.center {
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/expand/ExpandLoginAnomalyDetails.vue